import {ModalsProvider} from "@mantine/modals";

const { render } = wp.element; //we are using wp.element here!
import {
    MantineProvider,
    createTheme, Loader,
} from "@mantine/core";
import { Notifications } from '@mantine/notifications';
import '@mantine/core/styles.css';

import '@mantine/carousel/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';
import { HashRouter } from 'react-router-dom';
import {lazy, Suspense} from "@wordpress/element";
import {Provider} from 'react-redux';
import {store} from './app/store';
import {CssLoader, Initial as InitialLoader} from "./utils/loader/AppzaLoader";

const theme = createTheme({
    primaryColor: 'orange',
    fontFamily: 'Open Sans, sans-serif',
    components: {
        Loader: Loader.extend({
            defaultProps: {
                loaders: { ...Loader.defaultLoaders, custom: CssLoader },
                type: 'custom',
            },
        }),
    },
});

document.getElementById('appza-builder').setAttribute('style','overflow: hidden !important');
document.getElementById('adminmenumain').classList.add('folded');

if (document.getElementById('wpadminbar')){
    document.getElementById('wpadminbar').remove();
}
if (document.getElementById('wpfooter')){
    document.getElementById('wpfooter').remove();
}

document.getElementById('wpcontent').setAttribute('style','margin-left: 36px !important; padding-left: 0px !important');
document.getElementById('wpbody-content').setAttribute('style','padding-bottom: 0px !important');
document.getElementsByClassName('wp-toolbar')[0].style.paddingTop = '0px';




const App = lazy(() => import('./App'));



if (document.getElementById('appza-builder')) { //check if an element exists before rendering
    render(
            <HashRouter>
                <Provider store={store}>
                    <MantineProvider theme={theme} classNamesPrefix="appza-builder">
                        <Notifications />
                        <ModalsProvider labels={{ confirm: 'Submit', cancel: 'Cancel' }}>
                            <Suspense fallback={<InitialLoader/>}>
                                <App />
                            </Suspense>
                        </ModalsProvider>
                    </MantineProvider>
                </Provider>

             </HashRouter>,
        document.getElementById('appza-builder')
    );
}